import Types from './types';

export default class Dispatcher {
    constructor(dispatch) {
        this.dispatch = dispatch;
    }

    saveMoodStart = (payload) => this.dispatch({ type: Types.SAVE_MOOD_START, payload });

    fetchMoodHistoryStart = (days = 7) => this.dispatch({ type: Types.FETCH_MOOD_HISTORY_START, payload: { days } });

    saveJournalStart = (payload) => this.dispatch({ type: Types.SAVE_JOURNAL_START, payload });

    fetchJournalStart = (days = 30) => this.dispatch({ type: Types.FETCH_JOURNAL_START, payload: { days } });

    logSosStart = (payload) => this.dispatch({ type: Types.LOG_SOS_START, payload });

    saveActivityStart = (payload) => this.dispatch({ type: Types.SAVE_ACTIVITY_START, payload });

    fetchAlertsStart = () => this.dispatch({ type: Types.FETCH_ALERTS_START });

    fetchPatientSummaryStart = (clientId, days = 30) => this.dispatch({ type: Types.FETCH_PATIENT_SUMMARY_START, payload: { clientId, days } });

    resetError = () => this.dispatch({ type: Types.RESET_ERROR });
}
